<div class="rename-dialog">
  <div class="rename-header">
    <div class="hd-icon hd-icon-rename"></div>
    <div class="rename-header-text">
      {{ 'fileRenameItem_dialog_Title' | xsI18n }}
    </div>
    <div class="xs-dialog-close-btn" [soti-tooltip]="'lv-close' | xsI18n" placement="top"
    (click)="onCancel()"></div>
  </div>
  <div class="dialog-header-separator"></div>
  <div class="rename-body">
    <div class="rename-description">{{ 'fileRenameItem_Rename_Description' | xsI18n }}</div>

    <div class="rename-input">
      <span class="rename-caption">{{ 'fileRenameItem_Rename_Caption' | xsI18n }}</span>

      <app-text-input
        class="rename-text-input"
        [inputFormControl]="fileName"
        [maxLength]="200"
        (enterPressed)="onRename()"
      >
      </app-text-input>
    </div>
    <div class="error-label" ng-show="getErrorMessage()">{{ getErrorMessage() }}</div>
    <div class="warning-label" [hidden]="!isExtensionModified()">
      {{ 'fileRenameItem_Extension_Warning_Message' | xsI18n }}
    </div>
  </div>

  <div class="buttons-container">
    <button class="xs-btn btn-outline btn-space" (click)="onCancel()">{{ 'xs_cancel_label_short' | xsI18n }}</button>
    <button class="xs-btn btn-primary" (click)="onRename()" [disabled]="isDisabled()">
      {{ 'fileRenameItem_Rename_Button' | saI18n }}
    </button>
  </div>
</div>
